import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom'

import smoothscroll from 'smoothscroll-polyfill';

import Header from './Header';
import { Home } from './chapters/Home';
import { Progressbar } from './Progressbar';
import Footer from './chapters/Footer';
//import CookieBanner from './CookieBanner';
//import Integritetspolicy from './chapters/Integritetspolicy';
import ScrollToTop from './ScrollToTop';

export default function App() {
  
  const [currentChapter, setCurrentChapter] = useState(0)

  useEffect(() => {
    // Polyfill for smooth scrolling
    smoothscroll.polyfill();
  }, [])

  return (
    <div className="App" >  
      <Header />
      
      <Progressbar currentChapter={currentChapter} />
      
      <ScrollToTop setCurrentChapter={setCurrentChapter} />

      <Routes>
          <Route path="/" exact element={
            <Home setCurrentChapter={setCurrentChapter} /> 
          }/>
{/* 
          <Route path="/integritetspolicy" element={
            <Integritetspolicy />
          }/> 
*/}
      </Routes>


      <Footer />

{/*     <CookieBanner /> */}

    </div>
  );
}
